export default __webpack_public_path__ + "static/media/test-suite-sample.799f43e3.png";